import https from '@/utils/http'
import axios from 'axios'
const chat = {
    checkDemo:'/api/public/gpt/chatDemo',  // 未登录聊天
    web:'/api/public/gpt/v3/web',          // 登录后的聊天接口
    // 获取会话的统计信息
    getSessionStatData(params){
        return https({
            url:'/api/public/gpt/user/getSessionStat',
            method:"GET",
            params
        })
    },
    // 获取示例问题
    getDemoQuestions(){
        return https({
            url:'/api/public/gpt/getDemoQuestions',
            method:"GET",
        })
    },
    // 获取示例问题的答案
    getGPTAnswer(params){
        return https({
            url:'/api/public/gpt/getGPTAnswer',
            method:"GET",
            params
        })
    },
    // 智能瘦脸
    getLiquifyFace(data){
        return https({
            url:'/api/public/ImageGeneration/liquifyFace',
            method:"POST",
            data
        })
    },
    // 生成各种风格照片
    getGenerateStyles(data,cancelToken){
        try {
            return https({
                url:'/api/public/ImageGeneration/generateStyles',
                method:"POST",
                data,
                cancelToken
            })
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('Request canceled:', error.message);  // 捕获取消请求的异常
            } else {
                console.error(error);
            }
        }
    },
    // 获取照片处理风格列表
    getImageStyles(params){
        return https({
            url:'/api/public/ImageGeneration/getImageStyles',
            method:"GET",
            params
        })
    },
    // 绘画通用模版处理
    getCommonImage(_data,cancelToken){
        const data = JSON.stringify(_data);
        return https({
            url:'/api/public/ImageGeneration/common',
            method:"POST",
            contentType:'json',
            isToken:'no',
            data,
            cancelToken
        })
    },
    // 图生图转卡通两级标签
    getImageenhanStyles(params){
        return https({
            url:'/api/public/ImageGeneration/getImageenhanStyles',
            method:"GET",
            params,
        })
    },
    // 图生图图片卡通画
    getImageGeneration(data,cancelToken){
        return https({
            url:'/api/public/ImageGeneration/imageenhan',
            method:"POST",
            data,
            cancelToken
        })
    },
    // 文字生成图片
    getTextCreateImage(data,cancelToken){
        try {
            return https({
                url:'/api/public/ImageGeneration/create',
                method:"POST",
                data,
                cancelToken
            })
        } catch (error) {
            if (axios.isCancel(error)) {
                console.log('Request canceled:', error.message);  // 捕获取消请求的异常
            } else {
                console.error(error);
            }
        }
    },
}
export default chat;